import { OrdersApi, OrderUpdateResponseDto } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetUnreadUpdatesByOrderIdsQuery implements IQueryMessage {
  static type = 'getUnreadUpdatesByOrderIdsQueryHandler'
  type = GetUnreadUpdatesByOrderIdsQuery.type

  constructor(public ids: number[]) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

const httpClient = createApiClient(OrdersApi)

export const getUnreadUpdatesByOrderIdsQueryHandler: IQueryHandler<
  GetUnreadUpdatesByOrderIdsQuery,
  IEvent<OrderUpdateResponseDto[]>
> = async query => {
  const { data } = await httpClient.getUnreadUpdatesByOrderIds({ orderIds: query.ids })

  return new Event(GetUnreadUpdatesByOrderIdsQuery.type, data)
}
